export default "__VITE_ASSET__7aab825a__"